import { createAction } from 'redux-actions';

import { APP_LOADED, TransactionTypes } from '../../../settings/settings';
import { isCollegeExchange } from '../../../utils/transactions-util';
export const loadApplication = (actions) => {
  // Only college exchange should pass product type
  let productType;
  if (isCollegeExchange()) {
    productType = 'CollegeSavings';
  }
  return (dispatch) => {
    Promise.all([
      actions.getPersonalInformation(),
      dispatch(actions.getProductTypes()),
      dispatch(actions.getUserBeneficiaries()),
      dispatch(actions.getRMDLimits()),
      dispatch(actions.getUserFunds(TransactionTypes.EXCHANGE, productType)),
    ]).then(
      () => {
        actions.getBucketRollInformation();
        dispatch(createAction(`${APP_LOADED}_FULFILLED`)(true));
        actions.getMarketVolatilityInformation();
        dispatch(actions.getMoneyMarketEvent());
        dispatch(actions.getMoneyMarketEventMessage());
        dispatch(actions.getUserPaperlessSetting());
        dispatch(actions.getPendingTransactions());
        dispatch(actions.getRedeemThresholds());
        dispatch(actions.getTransactionLimits());
        actions.getRegistrationTypes();
        actions.getCostBasisInformation();
        actions.getStateWithholdingData();
        actions.setProgress(1);
      },
      () => {
        const action = createAction(`${APP_LOADED}_REJECTED`)(true);
        dispatch(action);
      }
    );
  };
};
